export enum RouterPaths {
  LANDING = '',
  MAIN = 'main',
  AUTH = 'auth',
  AUTH_LOGIN = 'auth/logowanie',
  AUTH_REGISTER = 'auth/rejestracja',
  AUTH_FORGOT_PASSWORD = 'auth/przypomnij-haslo',
  AUTH_RESET_PASSWORD = 'auth/zmien-haslo',
  CONFIRM_EMAIL_AFTER_REGISTER = 'auth/potwierdz-rejestracje',
  FINISH_REGISTER_GOOGLE = 'auth/potwierdz-rejestracje-google',
  SETTINGS = 'ustawienia',
  PRIVACY_POLICY = 'polityka-prywatnosci',
}
